module.exports = __webpack_public_path__ + "static/media/SF2011_03.e30134a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SF2011_03.jpg
// module id = 380
// module chunks = 0